import { Theme } from 'morpheus-ui';
import { tv } from 'tailwind-variants';

const borderWidthKeys = Object.keys(Theme.borderWidth);

export const button = tv(
  {
    base: 'flex items-center',
    variants: {
      size: {
        mini: 'py-0.5 px-1 gap-xxs text-xs rounded-sm',
        small: 'py-1 px-2 gap-xs text-sm rounded-sm',
        regular: 'py-2 px-4 gap-sm text-md rounded-md',
        large: 'py-3 px-4 gap-md text-lg rounded-md',
      },
      variant: {
        contained: 'bg-color-brand-primary text-button-color-primary-default',
        'contained-tonal':
          'bg-color-brand-secondary text-button-color-primary-default',
        outlined:
          'border-hairline border-mono-color-medium text-button-color-secondary-default',
        focusable:
          'text-mono-color-darkest hover:bg-color-lighter hover:text-button-color-tertiary-default focus:bg-color-lighter focus:text-button-color-tertiary-default',
        hoverable:
          'bg-transparent text-mono-color-darkest hover:text-button-color-tertiary-default',
        selected: 'bg-color-lighter text-button-color-tertiary-default',
        text: 'text-button-color-tertiary-default',
        black: 'text-mono-color-darkest',
      },
      orientation: {
        horizontal: 'flex-row',
        vertical: 'flex-col',
      },
      loading: {
        true: '',
      },
      negative: {
        true: '',
      },
      disabled: {
        true: 'cursor-not-allowed',
      },
      onlyIcon: {
        true: '',
      },
      full: {
        true: 'w-full justify-center',
        menu: 'w-full',
      },
    },
    compoundVariants: [
      {
        variant: 'contained',
        negative: true,
        className: 'bg-mono-color-lightest text-button-color-primary-negative',
      },
      {
        variant: 'outlined',
        negative: true,
        className:
          'text-button-color-secondary-negative border-mono-color-lightest',
      },
      {
        variant: 'text',
        negative: true,
        className: 'text-button-color-tertiary-negative',
      },
      {
        variant: 'contained',
        disabled: true,
        className: 'bg-color-medium text-button-color-primary-disabled',
      },
      {
        variant: 'outlined',
        disabled: true,
        className:
          'border-button-color-secondary-disabled text-button-color-secondary-disabled',
      },
      {
        variant: 'text',
        disabled: true,
        className: 'text-button-color-tertiary-disabled',
      },
      {
        variant: 'hoverable',
        disabled: true,
        className: 'text-mono-500',
      },
      {
        orientation: 'vertical',
        size: 'large',
        className: 'gap-sm py-3 px-3',
      },
      {
        orientation: 'vertical',
        size: 'regular',
        className: 'gap-0 py-2 px-2',
      },
      {
        orientation: 'vertical',
        size: ['small', 'mini'],
        className: 'gap-0',
      },
      {
        onlyIcon: true,
        size: 'large',
        className: 'gap-0 py-3 px-3',
      },
      {
        onlyIcon: true,
        size: 'regular',
        className: 'gap-0 py-2 px-2',
      },
      {
        onlyIcon: true,
        size: 'small',
        className: 'gap-0 py-1 px-1',
      },
      {
        onlyIcon: true,
        size: 'mini',
        className: 'gap-0 py-0.5 px-0.5',
      },
    ],
  },
  {
    twMergeConfig: {
      theme: {
        borderWidth: borderWidthKeys,
      },
    },
  }
);

export const buttonIcon = tv({
  variants: {
    iconSize: {
      mini: 'w-2 h-2',
      small: 'w-4 h-4',
      medium: 'w-5 h-5',
      regular: 'w-6 h-6',
      large: 'w-7 h-7',
    },
    variant: {
      contained: 'fill-current',
      'contained-tonal': 'fill-current',
      outlined: 'fill-current',
      focusable: 'fill-current stroke-0',
      hoverable: 'fill-current',
      selected: 'fill-current',
      text: 'fill-current',
      black: '',
    },
  },
});

export const buttonMaterialIcon = tv({
  variants: {
    iconSize: {
      mini: 'text-[8px]',
      small: 'text-[16px]',
      medium: 'text-[20px]',
      regular: 'text-[24px]',
      large: 'text-[28px]',
    },
    variant: {
      contained: 'fill-current',
      'contained-tonal': 'fill-current',
      outlined: 'fill-current',
      focusable: 'fill-current',
      hoverable: 'fill-current',
      selected: 'fill-current',
      text: 'fill-current',
      black: '',
    },
  },
});

export const loadingIcon = tv({
  base: 'fill-none stroke-current animate-spin',
  variants: {
    size: {
      mini: 'h-4',
      small: 'h-4',
      regular: 'h-5 ',
      large: 'h-6',
    },
    variant: {
      contained: 'fill-none stroke-button-color-primary-default',
      'contained-tonal': 'fill-none stroke-button-color-primary-default',
      outlined: 'fill-none stroke-button-color-secondary-default',
      focusable: 'fill-none stroke-current',
      hoverable: 'fill-none stroke-current',
      selected: 'fill-none stroke-button-color-tertiary-default',
      text: 'fill-none stroke-button-color-tertiary-default',
      black: '',
    },
  },
});
